const _wzEnv_ = window._wzEnv_ || {}
const _webConfig_ = window._webConfig_ || {}
export function getBaseDir() {
  return _wzEnv_.appDir || '/jianding'
}
import {isPlain} from './xp.v1'
export const CONFIG = _webConfig_;
export const isAppraiser = _webConfig_.isAppraiser || 0;
export const isLogin = _webConfig_.isLogin || 0;

// export function goHome(url, replace) {
//   url = url || `https://${HOST_WEB}`
//   if (replace === true) {
//     location.replace(url)
//   } else {
//     location.href = url
//   }
// }

// export function goBack(url) {
//   history.length > 1 ? history.go(-1) : goHome(url, true)
// }


export function cfg2arr(data){
    if(isPlain(data)){
      let arr = [];
      Object.keys(data).forEach((item) => {
          let obj = {}
          obj['text'] = data[item];
          obj['key'] = item;
          arr.push(obj)
      });
      return arr
    }
    return null
}